import { render, staticRenderFns } from "./ArticleTableOfContents.vue?vue&type=template&id=27fb073b&scoped=true&"
import script from "./ArticleTableOfContents.vue?vue&type=script&lang=ts&"
export * from "./ArticleTableOfContents.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleTableOfContents.vue?vue&type=style&index=0&id=27fb073b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fb073b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VCardText,VCardTitle,VDivider,VIcon,VList,VListItem,VListItemContent,VListItemTitle})
